import type { PlatformAPI } from './types'
import { ElectronAdapter } from './electron.adapter'
import { WebAdapter } from './web.adapter'
import { detectPlatform } from './detection'

/**
 * Platform Abstraction Layer
 * Main entry point for platform-specific functionality
 */

// Singleton instance
let platformAPI: PlatformAPI | null = null

/**
 * Get platform API instance (singleton)
 */
export function getPlatformAPI(): PlatformAPI {
  if (!platformAPI) {
    const platform = detectPlatform()

    if (platform === 'electron') {
      platformAPI = new ElectronAdapter()
    } else {
      platformAPI = new WebAdapter()
    }
  }

  return platformAPI
}

// Re-export types and utilities
export * from './types'
export * from './detection'
export { ElectronAdapter } from './electron.adapter'
export { WebAdapter } from './web.adapter'
